// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Nc","zenCrossSiteLabel":"Oc","vrsnlCrossSiteLabel":"Pc"};